
const headers = [
    {
      label: 'ชื่อ',
      field: 'roleName',
    },
    {
      label: 'สิทธิ์การใช้งาน',
      field: 'roleMenu',
      tdClass: 'text-center',
    },
    {
      label: 'ผู้ใช้งาน',
      field: 'roleUser',
      tdClass: 'text-center',
    },
    {
      label: 'สถานะการใช้งาน',
      field: 'isActive',      
    },
    {
      label: 'แก้ไขข้อมูลล่าสุด',
      field: 'updateDate', 
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers